import script from "./VouchersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VouchersPage.vue?vue&type=script&setup=true&lang=js"

import "./VouchersPage.vue?vue&type=style&index=0&id=9d922f92&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d922f92"]])

export default __exports__